module.exports = __webpack_public_path__ + "static/media/show_right_blob.e45c72cc.png";